import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmService } from "../../services/film.service";
import { PersonService } from "../../services/person.service";
import { ContentService } from "../../services/content.service";
import { FilmModel } from '../../models/film';
import { PersonModel } from '../../models/person';
import { ContentModel } from "../../models/content";

@Component({
  selector: 'site-articleContent',
  templateUrl: './articleContent.component.html',
  styleUrls: ['./articleContent.component.css']
})
export class ArticleContentComponent {

  @Input()
  directorSection: string;
  @Input()
  writerSection: string;
  @Input()
  cinematographerSection: string;
  @Input()
  editorSection: string;
  @Input()
  musicianSection: string;
  @Input()
  starSection: string[];
  @Input()
  publishDateHeader: string;
  @Input()
  publishDate: string;
  @Input()
  videoTitle: string;
  @Input()
  videoSubTitle: string;
  @Input()
  contributorList: ContentModel;
  @Input()
  videoReviewContributorTitle: string;
  @Input()
  videoReviewPublishDateHeader: string;
  @Input()
  videoReviewPublishDate: string;

  constructor(private personService:PersonService, private contentService:ContentService)
    {
    }

    ngOnInit(): void{
    }

    

  content: ContentModel;
  person: PersonModel;

  private getPerson(index: number): Observable<PersonModel>
  {
    return this.personService.getPerson(index).map((v,i)=>v);
  }

  private displayDirector(): string
  {
    let directorSectionHTML: string;
    directorSectionHTML="<div id=\"articlePageContentSub--Header1\" class=\"articlePageContentSub--Header\">" +
    "Directed By:" +
    "</div>" +
    "<div class=\"articlePageContentSub--Content\">" +
    this.directorSection +
    "</div>";
    return directorSectionHTML;
  }

  private displayWriter(): string
  {
    let writerSectionHTML: string;
    writerSectionHTML="<div class=\"articlePageContentSub--Header\">" +
    "Written By:" +
    "</div>" +
    "<div class=\"articlePageContentSub--Content\">" +
    this.writerSection +
    "</div>";
    return writerSectionHTML;
  }

  private displayCinematographer(): string
  {
    let cinematographerSectionHTML: string;
    cinematographerSectionHTML="<div class=\"articlePageContentSub--Header\">" +
    "Cinematography By:" +
    "</div>" +
    "<div class=\"articlePageContentSub--Content\">" +
    this.cinematographerSection +
    "</div>";
    return cinematographerSectionHTML;
  }

  private displayEditor(): string
  {
    let editorSectionHTML: string;
    editorSectionHTML="<div class=\"articlePageContentSub--Header\">" +
    "Editing By:" +
    "</div>" +
    "<div class=\"articlePageContentSub--Content\">" +
    this.editorSection +
    "</div>";
    return editorSectionHTML;
  }

  private displayMusician(): string
  {
    let musicianSectionHTML: string;
    musicianSectionHTML="<div class=\"articlePageContentSub--Header\">" +
    "Music By:" +
    "</div>" +
    "<div class=\"articlePageContentSub--Content\">" +
    this.musicianSection +
    "</div>";
    return musicianSectionHTML;
  }

  private displayStars(): string
  {
    let starsSectionHTML: string = "";
    let b: string[] = this.starSection;
    let previousStar: string;

    for(let i: number = 0; i<b.length; i+=2)
    {
      let tempStarName: string = b[i];
      let tempStarRole: string = b[i+1];
      
      //Checks to see if an actor has more than one role in a given film
      if (tempStarName === previousStar)
      {
        starsSectionHTML+="<div class=\"articlePageContentSub--Content\">" +
        tempStarRole +
        "</div>";
      }
      else if(i==0)
      {
        starsSectionHTML="<div id=\"articlePageContentSub--Header1\" class=\"articlePageContentSub--Header\">" +
        tempStarName +
        "</div>" +
        "<div class=\"articlePageContentSub--Content\">" +
        tempStarRole +
        "</div>";
      }
      else
      {
        starsSectionHTML+="<div class=\"articlePageContentSub--Header\">" +
        tempStarName +
        "</div>" +
        "<div class=\"articlePageContentSub--Content\">" +
        tempStarRole +
        "</div>";
      }
      previousStar=tempStarName;
    }
      

    return starsSectionHTML;
  }
  
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/articleContent/articleContent.component.ts